import React from 'react'
import { isJustGiving } from '../../../../lib/environment'
import withStyles from 'constructicon/with-styles'
import styles from './styles'

import { edhLight, edhDark, jgLight, jgDark } from '../../../../assets'

const platformConfig = (platform, theme) => {
  switch (platform) {
    case 'justgiving':
      return {
        image: {
          alt: 'JustGiving',
          src: theme === 'light' ? jgLight : jgDark
        },
        link: {
          title: 'Visit JustGiving',
          href: 'https://www.justgiving.com'
        }
      }
    default:
      return {
        image: {
          alt: 'Everydayhero',
          src: theme === 'light' ? edhLight : edhDark
        },
        link: {
          title: 'Visit Everydayhero',
          href: 'https://everydayhero.com'
        }
      }
  }
}

const PoweredBy = ({ classNames, environment = 'default', theme }) => {
  const defaultEnvironment = isJustGiving() ? 'justgiving' : 'everydayhero'
  const platform = environment === 'default' ? defaultEnvironment : environment
  const { image, link } = platformConfig(platform, theme)

  return (
    <div>
      <div className={classNames.label}>Powered by</div>
      <a {...link}>
        <img className={classNames.logo} {...image} />
      </a>
    </div>
  )
}

export default withStyles(styles)(PoweredBy)



// WEBPACK FOOTER //
// ./components/container/Footer/PoweredBy/index.js